const LOGO =
  "https://customer-assets.emergentagent.com/job_f3a45add-178a-4654-a651-71bba623af6b/artifacts/2b5l1hfl_Sagitta.png";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#0A0A0A] text-neutral-300"
    >
      {/* Keyword marquee removed per user request */}

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img
                src={LOGO}
                alt="Sagitta Corporativo"
                className="h-11 w-11 object-contain bg-white p-1"
              />
              <div>
                <div className="font-serif-display text-lg text-white tracking-wide">
                  SAGITTA
                </div>
                <div className="text-[10px] tracking-[0.32em] text-neutral-400">
                  CORPORATIVO
                </div>
              </div>
            </div>
            <p className="max-w-sm text-sm text-neutral-400 leading-relaxed">
              Nobleza Corporativa Sagitta.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.24em] text-neutral-500 mb-5">
              Navegación
            </div>
            <ul className="space-y-3 text-sm">
              {[
                ["Nosotros", "#nosotros"],
                ["Distintivos", "#distintivos"],
                ["Servicios", "#servicios"],
                ["Clientes", "#clientes"],
                ["Testimonios", "#testimonios"],
                ["Contacto", "#contacto"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a
                    href={href}
                    className="text-neutral-300 hover:text-[#E97906] transition-colors"
                  >
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.24em] text-neutral-500 mb-5">
              Contacto
            </div>
            <ul className="space-y-3 text-sm text-neutral-300">
              <li className="leading-relaxed">
                Calle Letran No. 4341, Int. 3, C.P. 45039, Residencial
                Cordilleras, Zapopan, Jalisco, México.
              </li>
              <li>Teléfono: Próximamente</li>
              <li>
                <a
                  href="mailto:contacto@corporativo-sagitta.com"
                  className="hover:text-[#E97906] transition-colors"
                >
                  contacto@corporativo-sagitta.com
                </a>
              </li>
              <li>
                <a
                  href="https://corporativo-sagitta.com"
                  className="hover:text-[#E97906] transition-colors"
                >
                  corporativo-sagitta.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-neutral-500">
          <div>
            © {new Date().getFullYear()} Sagitta Corporativo. Todos los derechos
            reservados.
          </div>
          <div className="font-serif-display italic text-neutral-400">
            Noblesse Oblige.
          </div>
        </div>
      </div>
    </footer>
  );
}
